import methods from "@/public/methods";
export default {
  ...methods,
  searchClear(srcData) {
    //清除搜索状态
    srcData.offset = 0;
    this.currentPage = 1;
    this.pagination.current = 1;
    // this.getFistHeight(srcData);
  },
  getFistHeight(srcData) {
    let TB = this.$refs.pubTable,
      n = 0;
    if (TB) {
      let el = TB.$el;
      if (el && el.offsetTop) {
        let oH = el.offsetTop;
        n = Math.ceil((window.innerHeight - 110 - oH) / 42); //公式解析  窗口高度- 表格头部高度分页高度和滚动条高度110 - 表格到窗口顶部高度 除以表格每条行高42 获得本表格可以显示的最大条数
        if (srcData && srcData.limit) {
          srcData.limit = Math.ceil(n / 10) * 10;
        }
      }
    }
    return n;
  },
  listTableChange(c) {
    //表格分页
    this.currentPage = c && c.current ? c.current : this.currentPage;
    this.pagination.current = this.currentPage;
    var params = { ...this.searchData };
    params.offset = (this.currentPage - 1) * c.pageSize;
    params.limit = c.pageSize;
    this.searchData = params;
    if (this.selectedRowKeys) {
      this.selectedRowKeys = [];
    }
    if (this.selectedRows) {
      this.selectedRows = [];
    }
    this.fetch();
    let tabBody = document.getElementsByClassName("ant-table-body");
    if (tabBody && tabBody.length) {
      for (let i = 0; i < tabBody.length; i++) {
        tabBody[i].scrollTop = 0;
      }
    }
  },
  fetch() {
    var _this = this;
    let a = axios({
      url: P.ajaxUrl + _this.listUrl,
      data: {
        ..._this.searchData
      },
      method: "post",
      type: "json"
    }).then(function(data) {
      let D = data.data;
      //更新表格
      if (D.resultCode == 0) {
        if (D.data) {
          const pagination = { ..._this.pagination };
          if (D.data.rows && D.data.rows.length) {
            _this.data = P.setKey(D.data.rows);
            pagination.total = Number(D.data.total);
            pagination.pageSize = _this.searchData.limit
              ? _this.searchData.limit
              : pagination.pageSize;
            _this.pagination = pagination;
          } else {
            if (D.data instanceof Array && D.data.length) {
              _this.data = P.setKey(D.data);
            } else {
              //_this.$message.error("暂无数据！");
              _this.data = [];
              _this.pagination.total = 0;
            }
          }
        }
      } else {
        _this.$error({
          title: "错误提示！",
          content: D.resultMessage
        });
      }
    });
    return a;
  },
  setTableHeight() {
    let indexHeight = this.$store.getters["getIndexHeight"];
    let id = this.$options.name + "Srcbox";
    let srcBox = document.getElementById(id),
      srcBoxHeight = 0;
    if (srcBox && srcBox.clientHeight) {
      srcBoxHeight = srcBox.clientHeight;
      sessionStorage.setItem(id + "srcBoxHeight", srcBoxHeight);
    } else {
      let h = Number(sessionStorage.getItem(id + "srcBoxHeight"));
      srcBoxHeight = h ? h : 0;
    }
    let tableHeight = indexHeight - srcBoxHeight - 120 - 20;
    //120 为表格表头+表格翻页高度 20 为表格表头距离搜索区域间隙
    return tableHeight; //120为表格头和表格翻页加底部滚动条的高度
  },
  // 计算table的x坐标
  countXScroll(arr) {
    return arr.reduce((previousValue, currentValue) => {
      if (currentValue.children) {
        return previousValue + countXScroll(currentValue.children);
      }
      return previousValue + (currentValue.width || 80);
    }, 0);
  }
};



// WEBPACK FOOTER //
// ./src/public/tablefun.js